import { EnquirySiteVisitStatus } from "features/EnquirySiteVisits/constants/enquiry-site-visit.constants";

/**
 * Mirrors backend `ALLOWED_FIELDS_BY_STATUS` for enquiry site visit updates.
 * Fields not listed for a status cannot be changed on edit.
 */
export const ENQUIRY_SITE_VISIT_ALLOWED_FIELDS_BY_STATUS: Record<
  EnquirySiteVisitStatus,
  readonly string[]
> = {
  [EnquirySiteVisitStatus.NEW]: [
    "address",
    "city",
    "state",
    "scheduledAt",
    "description",
    "priority",
    "attachments",
    "checklist",
  ],
  [EnquirySiteVisitStatus.IN_PROGRESS]: [
    "description",
    "attachments",
    "checklist",
  ],
  [EnquirySiteVisitStatus.COMPLETED]: [],
  [EnquirySiteVisitStatus.CANCELLED]: [],
};

/** Not returned by the API policy; keep locked on edit (create still allows). */
const EDIT_LOCKED_UNLESS_IN_POLICY = new Set(["enquiryId"]);

function normalizeStatus(status: string | null | undefined): string {
  return String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
}

export function getAllowedEnquirySiteVisitEditFields(
  status: string | null | undefined,
): ReadonlySet<string> {
  const key = normalizeStatus(status) as EnquirySiteVisitStatus;
  const list =
    ENQUIRY_SITE_VISIT_ALLOWED_FIELDS_BY_STATUS[key] ??
    ENQUIRY_SITE_VISIT_ALLOWED_FIELDS_BY_STATUS[EnquirySiteVisitStatus.NEW];
  return new Set(list);
}

export function isEnquirySiteVisitFieldEditable(
  fieldName: string,
  status: string | null | undefined,
  isEditMode: boolean,
): boolean {
  if (!isEditMode) return true;
  if (EDIT_LOCKED_UNLESS_IN_POLICY.has(fieldName)) return false;
  return getAllowedEnquirySiteVisitEditFields(status).has(fieldName);
}

export function hasAnyEnquirySiteVisitEditPermission(
  status: string | null | undefined,
): boolean {
  return getAllowedEnquirySiteVisitEditFields(status).size > 0;
}
